import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Donut, DonutValue, DonutLabel } from 'react-donut-component';

import StyleBase from '../../../styles/base';

interface Props {
  size?: number;
  strokeWidth?: number;
  trackColor: string;
  indicatorColor: string;
  value: number;
  label: string;
}

function DonutComponent(props: Props) {
  const classes = useStyles();
  return (
    <React.Fragment>
      <Donut
        animate={false}
        size={props.size}
        strokeWidth={props.strokeWidth}
        styleTrack={{ stroke: props.trackColor }}
        styleIndicator={{ stroke: props.indicatorColor }}
        linecap="round"
      >
        <DonutValue showValue={false}>{props.value}</DonutValue>
        <DonutLabel className={classes.donutLabel}>{props.label}</DonutLabel>
      </Donut>
    </React.Fragment>
  );
}
DonutComponent.defaultProps = {
  size: 80,
  strokeWidth: 8,
  trackColor: '#cfe8fc',
  indicatorColor: '#463264',
};

export default DonutComponent;

const useStyles = makeStyles({
  donutLabel: {
    color: '#323232',
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Poppins',
    [StyleBase.media.mobile]: {
      fontSize: 12,
    },
  },
});
